import React from 'react'
import { observer } from 'mobx-react'
import { CardContent } from 'components/Card'
import Button from 'components/Button'
import JobProgressionViewModel from '../JobProgressionViewModel'

interface DeliverableCompletedProgressionProps {
  vm: JobProgressionViewModel
  canCompleteJob?: boolean
}

export default observer(function DeliverableCompletedProgressionActions({
  vm,
  canCompleteJob,
}: DeliverableCompletedProgressionProps) {
  return (
    <>
      <CardContent>
        <Button
          type="primary"
          size="wide-slim"
          onClick={() => vm.closeJob()}
          dataTest="job-progression-complete-job-button"
          disabled={!canCompleteJob}
        >
          Complete Job
        </Button>
      </CardContent>
    </>
  )
})
